<template>
  <div id="Header">
    <div class="xv_navbar">
      <div class="row">
        <div class="col-6 xv_brand">
          <div class="xv_brand_logo">
            <img src="../../../assets/Thermometer_green.png" alt />
          </div>
          <div class="xv_brand_name">
            <span>Xerovi</span>
          </div>
        </div>
        <div class="col-6 xv_options">
          <!-- <div class="xv_lang">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              right
            >
              <template v-slot:button-content>
                <span>En</span>
              </template>
              <b-dropdown-item href="#">En</b-dropdown-item>
              <b-dropdown-item href="#">Es</b-dropdown-item>
              <b-dropdown-item href="#">Fr</b-dropdown-item>
            </b-dropdown>
          </div>-->
          <div class="demo_info_wrap">
            <div class="demo_info">
              <div class="count">8</div>
            </div>
            <div class="text">days left in demo</div>
            <div>
              <button class="main_btn">Upgrade</button>
            </div>
          </div>
          <div class="xv_user">
            <b-dropdown variant="link" toggle-class="text-decoration-none" right>
              <template v-slot:button-content>
                <img class="cvc_user_logo" src="../../../assets/user.jpg" alt />
              </template>
              <b-dropdown-item href="#">
                <span class="mdi mdi-account"></span>Account
              </b-dropdown-item>
              <b-dropdown-item href="#">
                <span class="mdi mdi-login"></span>Sign out
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 xv_nav_list">
          <button :class="{ active: active_nav == 'dashboard' }" @click="nav('dashboard')">
            <span class="mdi mdi-view-dashboard"></span>Dashboard
          </button>
          <button :class="{ active: active_nav == 'offices' }" @click="nav('offices')">
            <span class="mdi mdi-map-marker"></span>Offices
          </button>
          <button :class="{ active: active_nav == 'employees' }" @click="nav('employees')">
            <span class="mdi mdi-account-multiple"></span>Employees
          </button>
          <button
            :class="{ active: active_nav == 'health_declaration' }"
            @click="nav('health_declaration')"
          >
            <span class="mdi mdi-clipboard-text"></span>Health Declaration
          </button>
          <button :class="{ active: active_nav == 'reports' }" @click="nav('reports')">
            <span class="mdi mdi-google-analytics"></span>Reports
          </button>
          <button :class="{ active: active_nav == 'visitors' }" @click="nav('visitors')">
            <span class="mdi mdi-account-clock"></span>Visitors
          </button>
          <button
            :class="{ active: active_nav == 'visitors_security' }"
            @click="nav('visitors_security')"
          >
            <span class="mdi mdi-account-badge"></span>Visitors Security
          </button>
          <button :class="{ active: active_nav == 'alerts' }" @click="nav('alerts')">
            <span class="mdi mdi-email"></span>Alerts
            <sup class="xv_msg_count">4</sup>
          </button>
          <button :class="{ active: active_nav == 'settings' }" @click="nav('settings')">
            <span class="mdi mdi-settings"></span>Settings
          </button>
        </div>
      </div>
    </div>
    <div class="xv_skeleton"></div>
  </div>
</template>

<script>
export default {
  name: "Header",
  components: {},

  data() {
    return {
      active_nav: "dashboard"
    };
  },
  mounted() {
    var path = this.$route.path;
    var current_path = path.split("/");
    this.active_nav = current_path[current_path.length - 1];
  },
  methods: {
    nav: function(nav) {
      this.active_nav = nav;
      this.$router.push(nav);
    }
  }
};
</script>
